<div class="editor-backdrop">
	<section
		class="editor"
		role="dialog"
		aria-modal="true"
		aria-labelledby="walk-in-editor-title"
	>
		<header>
			<div>
				<span>{{ reservation() ? 'Επεξεργασία Κράτησης' : 'Νέα Κράτηση' }}</span>
				<h2 id="walk-in-editor-title">Walk-in</h2>
			</div>
			<button
				class="close-button"
				type="button"
				aria-label="Κλείσιμο"
				(click)="closed.emit()"
			>
				×
			</button>
		</header>
		<form
			[formGroup]="walkInForm"
			[class.validation-attempted]="validationAttempted()"
			(ngSubmit)="submit()"
		>
			<div class="editor-grid">
				<label>
					<span>Άτομα <b class="required-marker" aria-hidden="true">*</b></span>
					<div class="select-control">
						<select formControlName="partySize" required>
							@for (size of partySizeOptions; track size) {
								<option [ngValue]="size">
									{{ size }} {{ size === 1 ? 'άτομο' : 'άτομα' }}
								</option>
							}
						</select>
					</div>
				</label>
				<div class="form-field wide">
					<span>
						Ημερομηνία και ώρα
						<b class="required-marker" aria-hidden="true">*</b>
					</span>
					<div class="datetime-fields">
						<div class="date-control">
							<input
								formControlName="startsDate"
								[matDatepicker]="startsDatePicker"
								aria-label="Ημερομηνία κράτησης"
								readonly
								required
								(click)="startsDatePicker.open()"
							/>
							<button
								class="date-control__trigger"
								type="button"
								aria-label="Άνοιγμα ημερολογίου"
								(click)="startsDatePicker.open()"
							>
								<span class="icon icon--calendar" aria-hidden="true"></span>
							</button>
						</div>
						<div class="time-control">
							<input
								formControlName="startsTime"
								[matTimepicker]="startsTimePicker"
								aria-label="Ώρα κράτησης"
								readonly
								required
								(click)="startsTimePicker.open()"
							/>
							<button
								class="time-control__trigger"
								type="button"
								aria-label="Άνοιγμα επιλογής ώρας"
								(click)="startsTimePicker.open()"
							>
								<span class="time-icon" aria-hidden="true"></span>
							</button>
						</div>
					</div>
					<mat-datepicker #startsDatePicker></mat-datepicker>
					<mat-timepicker
						#startsTimePicker
						[options]="timeOptions()"
						aria-label="Επιλογή ώρας κράτησης"
					></mat-timepicker>
					@if (!timeOptionsLoading() && timeOptions().length === 0) {
						<small class="availability-note">
							{{
								timeOptionsFailed()
									? 'Δεν ήταν δυνατή η φόρτωση του ωραρίου.'
									: 'Το κατάστημα είναι κλειστό αυτή την ημέρα.'
							}}
						</small>
					}
				</div>
				<label>
					<span>Χώρος</span>
					<div class="select-control">
						<select formControlName="areaId">
							<option value="">Αυτόματη επιλογή</option>
							@for (
								area of operatorStateSrv.context()?.areas ?? [];
								track area.id
							) {
								<option [value]="area.id">{{ area.name }}</option>
							}
						</select>
					</div>
				</label>
				<label>
					<span>Τραπέζι</span>
					<div class="select-control">
						<select
							formControlName="tableId"
							(change)="selectTable($any($event.target).value)"
						>
							<option value="">
								{{
									availabilityLoading()
										? 'Έλεγχος διαθεσιμότητας…'
										: 'Αυτόματη ανάθεση'
								}}
							</option>
							@for (table of filteredTables(); track table.id) {
								<option [value]="table.id">
									{{ table.name }} · {{ table.seats }} θέσεις
								</option>
							}
						</select>
					</div>
					@if (!availabilityLoading() && filteredTables().length === 0) {
						<small class="availability-note">
							{{
								availabilityFailed()
									? 'Δεν ήταν δυνατός ο έλεγχος διαθεσιμότητας.'
									: 'Δεν υπάρχει διαθέσιμο τραπέζι.'
							}}
						</small>
					}
				</label>

				<button
					class="optional-details-toggle wide"
					type="button"
					aria-controls="walk-in-optional-details"
					[attr.aria-expanded]="showOptionalDetails()"
					(click)="toggleOptionalDetails()"
				>
					<span>More</span>
					<span
						class="icon icon--chevron-right"
						[class.is-expanded]="showOptionalDetails()"
						aria-hidden="true"
					></span>
				</button>

				<div
					id="walk-in-optional-details"
					class="optional-details wide"
					[hidden]="!showOptionalDetails()"
				>
					<label class="wide">
						<span>Σημείωση πελάτη</span>
						<textarea formControlName="customerNotes" rows="2"></textarea>
					</label>

					<label class="wide">
						<span>Εσωτερική σημείωση ομάδας</span>
						<textarea formControlName="operatorNotes" rows="2"></textarea>
					</label>

					<label>
						<span>Όνομα</span>
						<input formControlName="customerName" autocomplete="name" />
					</label>
					<label>
						<span>Τηλέφωνο</span>
						<input
							formControlName="customerPhone"
							type="tel"
							inputmode="tel"
							autocomplete="tel"
						/>
					</label>
				</div>
			</div>
			<footer>
				<button
					class="button button--light"
					type="button"
					(click)="closed.emit()"
				>
					Ακύρωση
				</button>
				<button
					class="button button--accent"
					type="submit"
				>
					{{ operatorStateSrv.saving() ? 'Αποθήκευση…' : 'Αποθήκευση' }}
				</button>
			</footer>
		</form>
	</section>
</div>
